export default __webpack_public_path__ + "static/media/lifts.66f9f431.svg";